import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
import Home from "./Home";
import Policies from "./Policies/Policy";
import PoliciesDetails from "./Policies/PolicyDetails";
import Manuals from "./Manuals/Manuals";
import ManualsItem from "./Manuals/ManualsItem";

export const DashBoardConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/dashboard",
        element: <Home />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
        ],
        path: "/policies",
        element: <Policies />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
        ],
        path: "/policies/:id",
        element: <PoliciesDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
        ],
        path: "/manuals",
        element: <Manuals />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
        ],
        path: "/manuals/:id",
        element: <ManualsItem />,
    },
];
